import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Warning } from 'phosphor-react';
import { Button } from '@/components/ui/Button';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';

export default function Legal() {
  const nav = useNavigate();
  const { signOut } = useAuth();

  async function deleteAccount() {
    if (!confirm('Supprimer définitivement votre compte et toutes vos données ?')) return;
    await supabase.rpc('delete_my_account');
    await signOut();
    nav('/login');
  }

  return (
    <div className="bg-paper text-ink-1 min-h-screen pb-tabbar">
      <header className="px-5 pt-[max(env(safe-area-inset-top),12px)] pb-3 flex items-center gap-3">
        <button onClick={() => nav(-1)} className="h-9 w-9 grid place-items-center rounded-full bg-paper-elev ring-1 ring-paper-edge"><ArrowLeft size={16} /></button>
        <span className="t-ed-lg">Supprimer mon compte</span>
      </header>

      <section className="px-5 mt-6 mb-10">
        <div className="flex items-start gap-3 p-4 rounded-xl bg-red-50 ring-1 ring-red-200 mb-6">
          <Warning size={20} className="text-red-600 shrink-0 mt-0.5" weight="fill" />
          <p className="t-ui text-red-800">
            La suppression est <strong>définitive et irréversible</strong>. Votre compte, vos favoris, vos alertes
            et toutes vos données personnelles seront effacés immédiatement.
          </p>
        </div>
        <Button variant="danger" full onClick={deleteAccount}>Supprimer définitivement mon compte</Button>
      </section>
    </div>
  );
}
